<template>
  <div>
    <div class="container-fluid white-bg no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>Дополнительное образование все больше набирает популярность. Родители стараются дать своим детям как можно больше возможностей устроить свое будущее. Для этого ребята ходят на различные секции, кружки, к репетиторам, в языковые центры. Но можно эффективно изучать иностранные языки не выходя из дома.</p>

            <h3 class="redh3">Что такое HomeTeacher?</h3>

            <p>Образовательная платформа HomeTeacher содержит в себе уроки-эпизоды, дополнительные материалы к ним и онлайн-тренажеры. Чтобы начать обучение, нужно выбрать и оплатить необходимый курс. Он будет доступен более года после оплаты. Это значит, можно в любое время повторить пройденный материал. На платформе предлагается пройти пробный урок совершенно бесплатно. Так вы сможете понять, подходит ли вашему ребенку такой формат обучения. Взрослым рекомендуется присутствовать на занятии, чтобы в любую минуту помочь, проверить правильность выполнения заданий.</p>

            <h3 class="greenh3">Преимущества изучения французского языка в Полиглотиках</h3>

            <ol>
              <li><span>Дистанционное обучение детей французскому языку помогает ребятам изучать один из самых распространенных языков в мире. Занятия проходят в привычной домашней обстановке. Ребенок всегда может остановить видео, чтобы выполнить задание, или посмотреть урок еще раз.</span></li>
              <li><span>Приобретая курс на платформе HomeTeacher, ученик получает занимательные видео уроки, дополнительные материалы к занятиям, тесты для проверки знаний.</span></li>
              <li><span>Онлайн курсы французского языка для детей дополнены консультациями с квалифицированными педагогами, в том числе с носителями языка. Преподаватель контролирует процесс изучения французского языка, дает советы по выбранной программе, отвечает на возникшие в ходе обучения вопросы. Стоит отметить, что все педагоги сети детских языковых центров Полиглотики проходят тщательный отбор. В свою команду мы принимаем только первоклассных специалистов, любящих детей и свое дело.</span></li>
              <li><span>Уроки построены на основе авторской методики, разработанной специалистами сети детских языковых центров Полиглотики. Обучение детей французскому языку проходит в игровой форме, преподаватель говорит только на изучаемом языке. Все программы основаны на современных достижениях в области нейропедагогики, нейрофизиологии, нейропсихологии и соответствуют требованиям ФГОС. Кроме того, методики обучения учитывают особенности русскоговорящих детей. Такой подход позволяет с легкостью познавать иностранный язык и культуру других стран.</span></li>
            </ol>

            <p>Онлайн-школа французского языка для детей практически не уступает очным занятиям с педагогом. Яркие занятия, интересные задания и красочные тесты дополнены обсуждениями с преподавателем достигнутых результатов. Ученик обучается в своем индивидуальном темпе, не нужно ориентироваться на ребят из группы. Уроки французского подойдут детям дошкольного возраста и подросткам.</p>

            <h3 class="redh3">В результате изучения французского языка&nbsp;на сайте poliglotiki.com ребенок научится:</h3>

            <ul>
              <li><span>слышать и воспринимать на слух французскую речь;</span></li>
              <li><span>пополнит словарный запас;</span></li>
              <li><span>занятия помогут развить творческое мышление, память и внимательность.</span></li>
            </ul>

            <p>Онлайн-уроки французского языка для детей с Полиглотиками &ndash; это удобный формат обучения, позволяющий в короткие сроки добиться хороших результатов. Ребенок запомнит много новых слов, разовьет навыки аудирования.</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang4"
}
</script>

<style scoped>
.no-shadow p,li{color: #000; font-size: 18px;}
.no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
.no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
.no-shadow{margin-bottom: 70px;}
.no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
.no-shadow li span {font-family: "Manrope Light"; color: #000;}
.no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
